export interface VehicleMediaUploadDTO {
  vehicleId: string;
  customerId: string;
  sequence?: number;
  mediaCategoryCode?: string;
  mediaType?: number[];
}
